// Customer Interfaces
export interface Customer {
    id: string;
    firstName: string;
    lastName: string;
    name?: string;
    email: string;
    phoneNumber: string;
    status: 'Active' | 'Suspended' | 'Pending';
    dateCreated: string;
    profileImageUrl?: string;
    address?: Address;
    totalSpend?: number;
    averageRating?: number;
    ratingCount?: number;
}

export interface Address {
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
}

export interface CustomerListResponse {
    results: Customer[];
    totalCount: number;
    page: number;
    pageSize: number;
}

// Order Interfaces
export interface Order {
    id: string;
    orderNumber: string;
    orderDate: string;
    status: string;
    total: number;
    items: OrderItem[];
}

export interface OrderItem {
    id: string;
    name: string;
    quantity: number;
    price: number;
    imageUrl?: string;
}

export interface OrderListResponse {
    results: Order[];
    totalCount: number;
    page: number;
    pageSize: number;
}

// Store Interfaces
export interface Store {
    id: string;
    name: string;
    location: string;
    status: string;
    contactEmail: string;
    contactPhone: string;
    logoUrl?: string;
}

export interface StoreListResponse {
    results: Store[];
    totalCount: number;
    page: number;
    pageSize: number;
}

// Status Utilities
export const getStatusColor = (status: string): string => {
    switch (status.toLowerCase()) {
        case 'active':
            return '#53C457';
        case 'suspended':
            return '#EC3237';
        case 'pending':
            return '#F59E0B';
        default:
            return '#707070';
    }
};

export const getStatusLabel = (status: string): string => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'Active';
        case 'suspended':
            return 'Suspended';
        case 'pending':
            return 'Pending';
        default:
            return status;
    }
};
